export default "__VITE_ASSET__BcBYxDfW__"